


















































import { Component } from 'vue-property-decorator';
import '@/assets/scss/pages/page-auth.scss';
import { BaseMixin } from '@/mixins/BaseMixin';
import { mixins } from 'vue-class-component';
import { FivGoalGroupType, IFivGoalGroup } from 'admiral-core';
import { FivApi } from '@/services/FivApi';
import GoalsOverviewTable from '@/views/pages/fivgoals/GoalsOverviewTable.vue';
import Multiselect from 'vue-multiselect';

@Component({
  name: 'kbv-goals-settings',
  components: { GoalsOverviewTable, Multiselect },
})
class KbvGoalsSettings extends mixins(BaseMixin) {
  selectedYear: number = new Date().getFullYear();

  latestBusinessPlanPlusGoalGroup: IFivGoalGroup | null = null;

  latestCompetitionWinnersClubGoalGroup: IFivGoalGroup | null = null;
  latestCompetitionFallAdsGoalGroup: IFivGoalGroup | null = null;
  async mounted() {
    await this.loadGoals();
  }
  async loadGoals() {
    const responseBusinessPlanPlus = await FivApi.getGoalGroup({
      user: this.user,
      groupType: FivGoalGroupType.BusinessPlanPlus,
      year: this.selectedYear,
    });
    this.latestBusinessPlanPlusGoalGroup = responseBusinessPlanPlus.data;

    const responseWinnersClub = await FivApi.getGoalGroup({
      user: this.user,
      groupType: FivGoalGroupType.CompetitionsKbv,
      year: this.selectedYear,
    });
    this.latestCompetitionWinnersClubGoalGroup = responseWinnersClub.data;

    const responseFallAds = await FivApi.getGoalGroup({
      user: this.user,
      groupType: FivGoalGroupType.CompetitionsKbv,
      year: this.selectedYear,
    });
    this.latestCompetitionFallAdsGoalGroup = responseFallAds.data;
  }

  get yearOptions() {
    return [2023, 2022, 2021];
  }

  labelYear(year: number) {
    return `Geschäftsjahr ${year}`;
  }
  async changed(year: number) {
    this.selectedYear = year;
    await this.loadGoals();
  }
}

export default KbvGoalsSettings;
